<flo-simple-header [siteId]="siteId$ | async"></flo-simple-header>
<div *ngIf="config$ | async as config" class="login-wrapper">
  <div class="standalone-login">
    <div class="funnel-form-wrapper">
      <div class="funnel-form-section">
        <div class="title-section mb-3">
          <h1 class="funnel-title">Log In</h1>
        </div>
        <p
          class="activation-code-message flo-footnote"
          *ngIf="!config.queryParams['embeddedPurchase']"
          >Log In or
          <a
            routerLink="../create-account"
            queryParamsHandling="merge"
            floAnalytics
            events="click"
            name="Sign Up"
            tabindex="-1"
            >Sign Up</a
          >
          before entering your activation code.</p
        >
        <flo-email-login
          (emailLoginSuccess)="handleEmailLoginSuccess($event)"
        ></flo-email-login>
        <div class="join-now-prompt funnel-form-footnotes">
          <p class="funnel-form-footnote flo-footnote"
            >Don't have an account?
            <a
              floAnalytics
              [routerLink]="['../create-account']"
              queryParamsHandling="merge"
              routerLinkActive="active"
              class="text-900 text-decoration-underline hover-grey-500"
              name="Go To Sign Up"
              >Sign Up</a
            ></p
          >
        </div>
        <div class="divider"><span>or</span></div>
        <div *ngIf="googleAuthError$ | async as googleAuthError" class="caption" data-test="googleAuthError">
          <p>{{ googleAuthError.displayText1 }}<br />{{ googleAuthError.displayText2 }}</p>
        </div>
        <flo-google-auth
          [isBrowser]="isBrowser"
          [googleSubmitting]="googleSubmitting"
          [googleClientKey]="googleAuthKey$ | async"
          (googleClicked)="handleGoogleButtonClick($event)"
          data-test="google-auth-button"
        ></flo-google-auth>
        <!-- Disabled until Apps in our Meta Developer account are back in compliance -->
        <!-- <flo-facebook-auth
          analyticsName="Facebook Login"
          (facebookSuccess)="handleFacebookLoginSuccess()"
        ></flo-facebook-auth> -->
      </div>
    </div>
  </div>
</div>
